document.addEventListener("DOMContentLoaded", function () {
  let remoteCodeLoaded = false;

  initModal();
  initCopyButton();
  clipboardButtonObserver();
  initDownloadButton();

  function initModal() {
    const code_modal = document.getElementById('code-modal');
    const code_open = document.getElementById('code-open');
    const code_close_list = document.querySelectorAll('.js-code-close');

    if (!code_open) return;
    code_open.addEventListener('click', () => {
      code_modal.classList.add('is-open');
      document.querySelector('body').style = "overflow: hidden;";
      loadRemoteCode();
    })
    code_close_list.forEach((code_close) => {
      code_close.addEventListener('click', () => {
        code_modal.classList.remove('is-open');
        document.querySelector('body').removeAttribute('style');
      })
    })
  }

  function initCopyButton() {
    document.querySelectorAll('.js-btn-copy-code').forEach((btn) => {
      btn.addEventListener('click', () => {
        const copy_to_clipboard_button = document.querySelector('button.copy-to-clipboard-button');
        copy_to_clipboard_button.click();
      })
    })

    document.querySelectorAll('.js-btn-copy-txt').forEach((btn) => {
      btn.addEventListener('click', () => {
        const dataText = btn.dataset.text;
        const btnSpan = btn.querySelector('span');
        const btnText = btnSpan.innerText;
        navigator.clipboard.writeText(dataText);
        if (btnText == "コピー完了") return;
        btnSpan.innerHTML = "コピー完了";
        setTimeout(() => {
          btnSpan.innerHTML = btnText;
        }, 3000);
      })
    })
  }

  function clipboardButtonObserver() {
    const copy_to_clipboard_button = document.querySelector('button.copy-to-clipboard-button');

    if (!copy_to_clipboard_button) return;

    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        if (mutation.type === 'attributes' && mutation.attributeName === 'data-copy-state') {
          const copyState = copy_to_clipboard_button.dataset.copyState;
          console.log('コピーの状態が更新されました:', copyState);
          document.querySelectorAll('.js-btn-copy-code-txt').forEach((btn) => {
            if (copyState == "copy-success") {
              btn.innerHTML = "コピー完了";
            } else if (copyState == "copy-error") {
              btn.innerHTML = "コピー失敗";
            } else {
              btn.innerHTML = "コードをコピー";
            }
          })
        }
      });
    });

    observer.observe(copy_to_clipboard_button, {
      attributes: true,
      attributeFilter: ['data-copy-state']
    });
  }

  // モーダルを開いた時に for_download のファイル本文を取得して表示（遅延ロード）
  function loadRemoteCode() {
    const codeEl = document.getElementById('provided-code-content');
    if (!codeEl) return;
    const url = codeEl.dataset.codeUrl;
    if (!url || remoteCodeLoaded) return;
    remoteCodeLoaded = true;

    fetch(url)
      .then((res) => {
        if (!res.ok) throw new Error('HTTP ' + res.status);
        return res.text();
      })
      .then((text) => {
        codeEl.textContent = text;
        if (window.Prism) Prism.highlightElement(codeEl);
        // 再ハイライトでコピーボタンが再生成されるため監視を貼り直す
        clipboardButtonObserver();
      })
      .catch((err) => {
        remoteCodeLoaded = false;
        codeEl.textContent = 'コードの読み込みに失敗しました。時間をおいて再度お試しください。';
        console.error('provided-code load failed:', err);
      });
  }

  function triggerDownload(blob, fileName) {
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.style.display = 'none';
    a.href = url;
    a.download = fileName;
    document.body.appendChild(a);
    a.click();
    window.URL.revokeObjectURL(url);
    document.body.removeChild(a);
  }

  function initDownloadButton() {
    document.querySelectorAll('.js-btn-download-code').forEach((btn) => {
      btn.addEventListener('click', () => {
        const fileName = btn.getAttribute('data-filename') || 'download.liquid';
        const codeUrl = btn.getAttribute('data-code-url');

        // for_download（ファイル参照）方式: CDNから取得してダウンロード
        if (codeUrl) {
          fetch(codeUrl)
            .then((res) => {
              if (!res.ok) throw new Error('HTTP ' + res.status);
              return res.blob();
            })
            .then((blob) => triggerDownload(blob, fileName))
            .catch((err) => {
              console.error('download failed:', err);
              alert('ダウンロードに失敗しました。時間をおいて再度お試しください。');
            });
          return;
        }

        // フォールバック: provided_code（テキスト）方式
        const codeContent = btn.getAttribute('data-code');
        if (!codeContent) {
          alert('ダウンロードするコードがありません。');
          return;
        }
        const textarea = document.createElement('textarea');
        textarea.innerHTML = codeContent;
        triggerDownload(new Blob([textarea.value], { type: 'text/plain' }), fileName);
      });
    });
  }
});